import React, { useState, useEffect, useRef } from 'react'
import './Preloading.css'
import { useSelector } from 'react-redux';

export default function Preloading({sx}) {
  const [imageUrl, setImageUrl] = useState([]);
  const canvasRef = useRef(null);
  const theme = useSelector(state => state.themeData);
  
  // Static image URL - replace with your actual image
  const sourceImageUrl = theme.images.loading;
  // Fallback for demo
  const fallbackImageUrl = 'https://picsum.photos/300/300?random=1';
  
  useEffect(() => {
    splitImage();
  }, []);

  const splitImage = () => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const parts = [];
      
      // Set canvas size to match image
      canvas.width = img.width;
      canvas.height = img.height;
      
      // Calculate dimensions for each part (3x3 grid)
      const partWidth = img.width / 3;
      const partHeight = img.height / 3;
      
      // Create 9 parts in the correct order
      for (let row = 0; row < 3; row++) {
        for (let col = 0; col < 3; col++) {
          // Create a new canvas for each part
          const partCanvas = document.createElement('canvas');
          partCanvas.width = partWidth;
          partCanvas.height = partHeight;
          const partCtx = partCanvas.getContext('2d');
          
          // Draw the specific part of the image
          partCtx.drawImage(
            img,
            col * partWidth, row * partHeight, partWidth, partHeight, // source
            0, 0, partWidth, partHeight // destination
          );
          
          // Convert to data URL
          const dataUrl = partCanvas.toDataURL('image/png');
          parts.push(dataUrl);
        }
      }
      
      setImageUrl(parts);
    };
    
    img.onerror = () => {
      console.error('Failed to load image, using fallback');
      // Try fallback image
      img.src = fallbackImageUrl;
    };
    
    // Try main image first, fallback on error
    img.src = sourceImageUrl || fallbackImageUrl;
  };

  return (
    <div className='containerOfPreloading' 
    style={{
      ...sx
    }}
    >
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      <section>
        <div className='sk-cube-grid'>
          {imageUrl?.map((url, index) => {
            return (
              <div key={"preloading_key_"+index} className={'sk-cube sk-cube-'+(index+1)}
                style={{
                  backgroundImage: `url(${url})`,
                }}
              ></div>
            )
          })}
        </div>
      </section>
    </div>
  )
}